// Libraries
import React, { Component } from 'react';
import renderHTML from 'react-render-html';

import { translate } from '../../globals/translations';

/**
 * Checkbox
 *
 * For rendering a generic form select
 *
 * @since 0.5
 * @package /app/globals/form-fields
 */

class Checkbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: '',
            checkVisible: '-hidden',
            checked: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * componentWillMount
     *
     * This method runs before this component is rendered(mounted) to the DOM
     * to set the initial checkbox state
     *
     * @since 0.5
     *
     * @param {n/a}
     * @return {n/a}
     *
     */
    UNSAFE_componentWillMount() {
        if (
            this.props.value !== '' &&
            this.props.value !== undefined &&
            this.props.value !== 'no'
        ) {
            this.setState({
                inputValue: this.props.value,
                checkVisible: '',
                checked: true,
            });
        }
    }

    handleChange(e) {
        const checkbox = e.target;

        if (checkbox.value == '') {
            this.setState({
                inputValue: 'yes',
                checked: true,
                checkVisible: '',
            });

            if (checkbox.name == 'privacy_policy') {
                const errorMsg = document.querySelector(
                    `span[data-for=${checkbox.name}]`
                );

                if (!errorMsg.classList.contains('-hidden')) {
                    errorMsg.classList.add('-hidden');
                }
            }
        } else {
            this.setState({
                inputValue: '',
                checkVisible: '-hidden',
                checked: false,
            });

            if (checkbox.name == 'privacy_policy') {
                const errorMsg = document.querySelector(
                    `span[data-for=${checkbox.name}]`
                );

                if (errorMsg.classList.contains('-hidden')) {
                    errorMsg.classList.remove('-hidden');
                }
            }
        }
    }

    render() {
        if (this.props.name == 'privacy_policy') {
            let checkbox_text =
                translate('agree_label') +
                (this.props.contest_url != ''
                    ? `<a href=${this.props.contest_url} target="_blank">` +
                      translate('contest_link') +
                      `</a>` +
                      translate('and')
                    : '') +
                `<a href=${this.props.privacy_url} target="_blank">` +
                translate('policy_link') +
                `</a>.`;

            let error_text =
                translate('please_policy_agree') +
                (this.props.contest_url != ''
                    ? translate('contest_no_link') + translate('and')
                    : '') +
                translate('policy_no_link');

            return (
                <div className="form-group-container">
                    <div className="form-group checkbox">
                        <label htmlFor={this.props.name}>
                            <div className="conditions-label">
                                {translate('terms_conditions') + ' *'}
                            </div>
                            <div className="checkbox-container">
                                <span
                                    className={`check-input-container ${this.state.checkVisible}`}
                                >
                                    <input
                                        type="checkbox"
                                        id={this.props.name}
                                        className="form-control required"
                                        name={this.props.name}
                                        value={this.state.inputValue}
                                        onChange={this.handleChange}
                                        checked={this.state.checked}
                                        aria-required="true"
                                    />
                                </span>
                                <span>{renderHTML(checkbox_text)}</span>
                            </div>
                        </label>
                        <span
                            className="form-error-msg -hidden"
                            data-for={this.props.name}
                        >
                            {error_text}
                        </span>
                    </div>
                </div>
            );
        } else {
            let labelText = this.props.labelText;

            if (
                this.props.name == 'promotion_emails' &&
                this.props.privacy_url
            ) {
                labelText +=
                    ` <a href=${this.props.privacy_url} target="_blank">` +
                    translate('policy_link') +
                    `</a>`;
            }

            return (
                <div className="form-group-container">
                    <div className="form-group checkbox">
                        <label htmlFor={this.props.name}>
                            <div className="conditions-label">
                                {translate('terms_conditions') + ' *'}
                            </div>
                            <div className="checkbox-container">
                                <span
                                    className={`check-input-container ${this.state.checkVisible}`}
                                >
                                    <input
                                        type="checkbox"
                                        id={this.props.name}
                                        className="form-control"
                                        name={this.props.name}
                                        value={this.state.inputValue}
                                        onChange={this.handleChange}
                                        checked={this.state.checked}
                                        aria-required="true"
                                    />
                                </span>
                                <span>{renderHTML(labelText)}</span>
                            </div>
                        </label>
                    </div>
                </div>
            );
        }
    }
}

export default Checkbox;
